import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import { LoginCallback } from "@okta/okta-vue";
import globals from "@/globals";
import auth from "@/services/auth.svc";

// Layouts
import Layout1 from "@/layout/Layout1";

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  base: "/",
  mode: "history",
  routes: [
    {
      path: "/",
      component: Layout1,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "",
          component: () => import("@/components/Home"),
          meta: {
            requiredRoles: ["SearchAdmin"]
          }
        }
      ]
    },
    // {
    //   path: "/login",
    //   component: () => import("@/views/Login.vue"),
    //   meta: {
    //     allowAnon: true
    //   }
    // },
    // {
    //   path: "/unauthorized",
    //   name: "unauthorized",
    //   component: () =>
    //     import(/* webpackChunkName: "404" */ "@/pages/Unauthorized.vue"),
    //   props: true,
    // },
    {
      path: "/login/callback",
      component: LoginCallback,
    },
    {
      path: "/logout",
      component: () =>
        import(/* webpackChunkName: "logout" */ "@/views/Logout.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: () => import("@/views/Unauthorized.vue"),
      meta: {
        allowAnon: true
      }
    }
  ]
});

router.afterEach(() => {
  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10);
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0);
});

// router.beforeEach((to, from, next) => {
//   // Set loading state
//   document.body.classList.add("app-loading");

//   let isAuthed = !!auth.getUser();
//   if (!isAuthed) {
//     let allowAnon = to.meta.allowAnon;
//     if (!allowAnon) {
//       next("/login");
//     }
//   }
//   if (to.meta.requiredRoles) {
//     auth.getSearchRoles().then(roles => {
//       let canAccess =
//         roles && roles.some(p => to.meta.requiredRoles.indexOf(p) > -1);

//       if (!canAccess) {
//         next("/unauthorized");
//       }
//     });
//   }
//   // Add tiny timeout to finish page transition
//   setTimeout(() => next(), 10);
// });

export default router;
